export const SUPPORTED_TRUCKS = "SUPPORTED_TRUCKS";
export const SUPPORTED_TRAILERS = "SUPPORTED_TRAILERS";
export const SUPPORTED_TRAILER_TYPES = "SUPPORTED_TRAILER_TYPES";
export const SUPPORTED_PAYMENT_TYPES = "SUPPORTED_PAYMENT_TYPES";
